import i18n from 'i18next'
import parsePhoneNumberFromString from 'libphonenumber-js'
import { initReactI18next } from 'react-i18next'

import enARIBIO from './en_ARIBIO.json'
import enATRIA from './en_ATRIA.json'
import enCA from './en_CA.json'
import enCLINCLOUD from './en_CLINCLOUD.json'
import enGB from './en_GB.json'
import enJDR from './en_JDR.json'
import enSTUDYKIK from './en_STUDYKIK.json'
import enUS from './en_US.json'
import esCLINCLOUD from './es_CLINCLOUD.json'
import esSTUDYKIK from './es_STUDYKIK.json'
import esUS from './es_US.json'
import frCA from './fr_CA.json'
import frFR from './fr_FR.json'
import jaJP from './ja_JP.json'

export function setupLanguages(language: string) {
    i18n.use(initReactI18next).init({
        debug: process.env.NODE_ENV === 'development',
        resources: {
            en_US: {
                translation: enUS,
            },
            en_GB: {
                translation: enGB,
            },
            es_US: {
                translation: esUS,
            },
            en_ARIBIO: {
                translation: enARIBIO,
            },
            en_JDR: {
                translation: enJDR,
            },
            en_ATRIA: {
                translation: enATRIA,
            },
            en_STUDYKIK: {
                translation: enSTUDYKIK,
            },
            es_STUDYKIK: {
                translation: esSTUDYKIK,
            },
            en_CLINCLOUD: {
                translation: enCLINCLOUD,
            },
            es_CLINCLOUD: {
                translation: esCLINCLOUD,
            },
            ja_JP: {
                translation: jaJP,
            },
            fr_FR: {
                translation: frFR,
            },
            fr_CA: {
                translation: frCA,
            },
            en_CA: {
                translation: enCA,
            },
        },
        lng: language,
        fallbackLng: 'en_US',
        interpolation: {
            format: function (value, format) {
                if (format === 'phone') {
                    const phoneNumber = parsePhoneNumberFromString(value)
                    return phoneNumber ? phoneNumber.formatInternational() : value
                }
                return value
            },
        },
    })
}
